import PopoverWrapper from './PopoverWrapper'

export default PopoverWrapper



// WEBPACK FOOTER //
// ./src/components/PopoverWrapper/index.js